<div class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[60] p-4">
  <form [formGroup]="commentForm"
    class="bg-white rounded-lg shadow-xl p-4 sm:p-6 w-full max-w-sm sm:max-w-md animate-scale-in"
    (ngSubmit)="onSubmitFeedback()">
     <div class="flex justify-between items-center mb-[16px]">
      <h3 class="text-lg font-medium text-gray-900">
  {{ 'guard-shift-details.finish.guardFeedback.title' | translate:{ 
        guardName: data?.firstName + (data?.lastName ? ' ' + data?.lastName : '') || 'guard' 
      } }}
</h3>
      <button (click)="onCancel()" class="text-gray-400 hover:text-gray-500 p-[4px]" aria-label="Close feedback popup">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
          style="margin: 0 0 12px 0;" stroke="currentColor" stroke-width="2" stroke-linecap="round"
          stroke-linejoin="round" class="lucide lucide-x">
          <path d="M18 6 6 18"></path>
          <path d="m6 6 12 12"></path>
        </svg>
      </button>

    </div>
    <p class="text-sm text-gray-600 mb-4">
      {{ 'guard-shift-details.finish.guardFeedback.description' | translate }}
    </p>

    <textarea id="feedback-textarea" formControlName="comment"
      class="w-full border border-gray-300 rounded-md p-3 mb-4 focus:ring-blue-500 focus:border-blue-500 min-h-[100px] placeholder:text-gray-400"
      rows="4" [placeholder]="'guard-shift-details.finish.guardFeedback.placeholder' | translate">
    </textarea>

    <div class="flex flex-col sm:flex-row sm:justify-end gap-3">
      <button type="button" (click)="onCancel()" id="cancel-btn"
        class="w-full sm:w-auto px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50 transition-colors" aria-label="Cancel">
        {{ 'guard-shift-details.finish.guardFeedback.cancel' | translate }}
      </button>

      <button type="submit" id="submit-btn" [disabled]="commentForm.invalid"
        class="w-full sm:w-auto px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:opacity-50 transition-colors" aria-label="Submit">
        {{ 'guard-shift-details.finish.guardFeedback.submit' | translate }}
      </button>
    </div>
  </form>
</div>